"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceMappingToJSON = exports.AudienceMappingFromJSONTyped = exports.AudienceMappingFromJSON = exports.instanceOfAudienceMapping = void 0;
var runtime_1 = require("../runtime");
var AdSetType_1 = require("./AdSetType");
/**
 * Check if a given object implements the AudienceMapping interface.
 */
function instanceOfAudienceMapping(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceMapping = instanceOfAudienceMapping;
function AudienceMappingFromJSON(json) {
    return AudienceMappingFromJSONTyped(json, false);
}
exports.AudienceMappingFromJSON = AudienceMappingFromJSON;
function AudienceMappingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audienceId': !(0, runtime_1.exists)(json, 'audience_id') ? undefined : json['audience_id'],
        'segmentId': !(0, runtime_1.exists)(json, 'segment_id') ? undefined : json['segment_id'],
        'audienceType': !(0, runtime_1.exists)(json, 'audience_type') ? undefined : (0, AdSetType_1.AdSetTypeFromJSON)(json['audience_type']),
    };
}
exports.AudienceMappingFromJSONTyped = AudienceMappingFromJSONTyped;
function AudienceMappingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audience_id': value.audienceId,
        'segment_id': value.segmentId,
        'audience_type': (0, AdSetType_1.AdSetTypeToJSON)(value.audienceType),
    };
}
exports.AudienceMappingToJSON = AudienceMappingToJSON;
